import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { Country } from '../models/business';

/**
 * The ISO-3166 country catalog (#5121), served by the API from the same Nager.Country data it validates
 * saves against — so a picker can never offer a code the API will reject.
 *
 * Cached for the session: ~250 rows that cannot change between requests, and every form that asks for a
 * country would otherwise refetch the whole list.
 */
@Injectable({ providedIn: 'root' })
export class CountryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/countries';

  private countries$?: Observable<ApiResponse<Country[]>>;

  public getAll(): Observable<ApiResponse<Country[]>> {
    this.countries$ ??= this.httpClient.get<ApiResponse<Country[]>>(this.baseUrl).pipe(shareReplay({ bufferSize: 1, refCount: false }));

    return this.countries$;
  }
}
